import withAemIntegration from "../../../../withAemIntegration";

const ComponentEditConfig = {
  emptyLabel: "Vehicle Configurator - Image Tools",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};


const ComponentConfig = (props) => {
  return <div></div>;
};

export default withAemIntegration("lexus/components/build/data-dialogs/image-tools")(ComponentConfig, ComponentEditConfig);